/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface ReceiptControllerSearchCurrentMonthData$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 시작일
 */
  centerId: string;

/**
 * 보호자 이름
 */
  gender?: 'MALE' | 'FEMALE';

/**
 * 담당 선생님
 */
  centerUserIds?: Array<string>;

/**
 * 보호자
 */
  guardianIds?: Array<string>;

/**
 * 아동
 */
  childIds?: Array<string>;

/**
 * 치료 유형
 */
  ticketTypeIds?: Array<string>;

/**
 * 서비스
 */
  ticketIds?: Array<string>;

/**
 * 검색 월
 */
  month?: string;

/**
 * 검색 년도
 */
  year?: string;

/**
 * 시작일
 */
  startDate?: string;

/**
 * 종료일
 */
  endDate?: string;
}

export function receiptControllerSearchCurrentMonthData(http: HttpClient, rootUrl: string, params: ReceiptControllerSearchCurrentMonthData$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerSearchCurrentMonthData.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('centerId', params.centerId, {});
    rb.query('gender', params.gender, {});
    rb.query('centerUserIds', params.centerUserIds, {});
    rb.query('guardianIds', params.guardianIds, {});
    rb.query('childIds', params.childIds, {});
    rb.query('ticketTypeIds', params.ticketTypeIds, {});
    rb.query('ticketIds', params.ticketIds, {});
    rb.query('month', params.month, {});
    rb.query('year', params.year, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

receiptControllerSearchCurrentMonthData.PATH = '/api/receipt/center-child/current-month';
